import { render } from "./TabItem.vue?vue&type=template&id=68cbe403&scoped=true"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"

import "./TabItem.vue?vue&type=style&index=0&id=68cbe403&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cbe403"],['__file',"src/scripts/common/components/TabItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68cbe403"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68cbe403', __exports__)) {
    api.reload('68cbe403', __exports__)
  }
  
  module.hot.accept("./TabItem.vue?vue&type=template&id=68cbe403&scoped=true", () => {
    api.rerender('68cbe403', render)
  })

}


export default __exports__